<div pplFocusTrap>
  <ppl-provider-classification-questions #questions [form]="classificationForm"
    [mode]="mode"></ppl-provider-classification-questions>

  @if (!readOnly) {
  <div class="custom-row">
    @if (mode === 'edit') {
    <ppl-button label="Cancel" icon="fa fa-ban" [customClass]="'alt-button'" [iconPosition]="'left'"
      (click)="onCancel()"></ppl-button>
    <ppl-button label="Save" icon="fa fa-floppy-o" [customClass]="'alt-button'" [iconPosition]="'left'"
      [disabled]="isSaving" (click)="onSave()"></ppl-button>
    } @else {
    <ppl-button label="Edit" icon="fa fa-pencil" [customClass]="'ghost-button'" [iconPosition]="'left'"
      (click)="onEdit()"></ppl-button>
    }
  </div>
  }
</div>
